module.exports = __webpack_public_path__ + "static/img/JP.6ad8079.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping/JP.png
// module id = 8bRx
// module chunks = 2